module.exports = __webpack_public_path__ + "static/img/10.a914388c.jpg";